import { render, staticRenderFns } from "./VetUploadPublic.vue?vue&type=template&id=2e509e5c&"
import script from "./VetUploadPublic.vue?vue&type=script&lang=js&"
export * from "./VetUploadPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports